import { useState } from 'react'
import { SystemSS } from '../../components/SystemSS'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const ButtleFlowStep5 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-step5-fr.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    Pour terminer une carte, vous devez vaincre tous les ennemis en <span className='text-pborange'>réduisant leurs PV à 0</span>. Une fois que
                    les PV d'un ennemi tombent à 0, il est neutralisé. Vous pouvez aussi <span className='text-pborange'>les éliminer complètement de la
                    carte en les faisant passer en état de Désâmisation</span>. Par ailleurs, il existe des cartes avec des
                    conditions de <span className='text-pborange'>victoire spéciales</span>, qui s'afficheront au début de la carte.
                </p>{' '}
                <p className=' '>
                    Les personnages qui subissent des dégâts et tombent à 0 PV seront neutralisés et resteront sur
                    place. <span className='text-pborange'>S'ils sont ressuscités, ils pourront de nouveau participer au combat.</span>
                </p>{' '}
                <p className=' '>
                    Si des personnages neutralisés ne sont pas ressuscités et qu'ils subissent des dégâts
                    supplémentaires, ils passeront en état de Désâmisation et <span className='text-pborange'>disparaîtront complètement</span>.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-5',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Les alliés en état de Désâmisation peuvent être ressuscités à la base.
'
                />
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </section>
    )
}
